import React from "react";
import { Div, Icon, Text } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { useParams } from "react-router";
import { useLanguageNavigate } from "../../../Hooks/useLanguageNavigate";
import { useUserServices } from "../../../Store/modules/subService/userServices";

export type PageTitleProps = {
  title: string;
  description?: string;
  className?: string;
  actionTitle?: string;
  onActionClick?: VoidFunction;
  broadComb?: boolean;
  serviceName?: string;
  categoryName?: string;
  categoryId?: number | string;
  onServiceNameClick?: () => void;
};

export const PageTitle: React.FC<PageTitleProps> = (props) => {
  const {
    title,
    description,
    className,
    actionTitle,
    onActionClick,
    broadComb,
    categoryName,
    serviceName,
    categoryId,
    onServiceNameClick,
  } = props;
  const { direction, locale } = useLanguage();

  const router = useLanguageNavigate();

  return (
    <div className={className ? className : ""} dir={direction}>
      <div className="flex justify-between items-center">
        <div className="flex flex-col w-full">
          <div className="flex items-center " dir={direction}>
            <Div className="w-full" dir={direction}>
              <Text elementType="h1" className="xs:text-lg md:text-[20px]" fontWeight={600}>
                {title}
              </Text>
            </Div>
            {actionTitle ? (
              <div
                className="flex items-center justify-end pointer font-[500]"
                onClick={() => onActionClick && onActionClick()}
              >
                <Text
                  elementType="span"
                  className="xs:text-sm md:text-base mx-1 !text-[13px] flex-shrink-0"
                  color="primary"
                >
                  {actionTitle}
                </Text>
                <Icon
                  className="flex-shrink-0"
                  Component={locale === "fa" ? ArrowLeft2 : ArrowRight2}
                  color="primary"
                  size={18}
                />
              </div>
            ) : null}
          </div>
          {description ? (
            <div dir={direction} className="w-full">
              <Text elementType="p" className="text-xs mt-1.5" color="text" fontWeight={300}>
                {description}
              </Text>
            </div>
          ) : null}
        </div>

        {broadComb ? (
          <div dir={direction} className="flex items-center xs:mt-0 md:mt-2 whitespace-nowrap">
            <Text
              elementType="span"
              className="text-xs"
              color="iconColor"
              fontWeight={500}
              onClick={() => router(`/Services/${categoryId}`)}
            >
              {categoryName}
            </Text>
            <Icon
              Component={locale === "fa" ? ArrowLeft2 : ArrowRight2}
              size={16}
              color="iconColor"
              className="mx-1"
            />
            <Text
              elementType="span"
              color="primary"
              className="text-xs"
              fontWeight={600}
              onClick={onServiceNameClick}
            >
              {serviceName}
            </Text>
          </div>
        ) : null}
      </div>
      <Div bg="tertiary" className="w-full h-[1px] mt-[10px]" />
    </div>
  );
};
